module.exports = __webpack_public_path__ + "static/chunks/src/page-ottawa/part-why-replace/assets/image-cause-01.0a87a1cf97bdcf0de9ce3e4c277e175c.webp";